import BaseStore from './BaseStore';
import StationFtpModel from "../models/StationFtpModel";

export default class StationFtpStore extends BaseStore {

  constructor(transportLayer) {
    super(StationFtpModel, transportLayer);
  }

  fetchConfiguration(station_id) {
    return this.transportLayer.fetchById(station_id);
  }

  updateConfiguration(station_id, json){
    return this.transportLayer.update(station_id, json);
  }

  fetchStationFtpData(station_id, filters) {
    return this.transportLayer.fetchData(station_id, filters)
  }

};


// WEBPACK FOOTER //
// ./src/stores/StationFtpStore.js